export const AppLanguages = {
	ENGLISH: "en",
	SPANISH: "es",
	DEFAULT: "en",
}
